module.exports = __webpack_public_path__ + "static/media/Mask.97ff8026.png";